import React from 'react';
import { SEO } from '../components/SEO';
import { UseCasesSection } from '../components/UseCasesSection';
import MainLayout from '../layouts/main';

export default () => {
  return (
    <MainLayout>
      <SEO
        pathname="/use-cases/"
        title="Publisher Use Cases"
        description="Commerce growth solutions for news and media publishers, newsletters, shopping and loyalty platforms, and publisher finance teams."
      />
      <UseCasesSection />
    </MainLayout>
  );
};
